import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel } from 'rsuite';
import * as SolidIcons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MembersAreaService from '../../../../services/MemberArea.service';

const PostPanelList = ({ courseId }) => {
  const [displayPosts, setDisplayPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await new MembersAreaService().get(`posts/top/${courseId}`);
        const { postsWithComments = [], recentPosts = [] } = response;

        const mostCommented = postsWithComments
          .filter(post => (post.answers?.length ?? 0) > 0)
          .sort((a, b) => (b.answers?.length ?? 0) - (a.answers?.length ?? 0));

        const combinedPosts = mostCommented.length > 0
          ? [...mostCommented, ...recentPosts]
          : recentPosts;

        setDisplayPosts(combinedPosts.slice(0, 5));
      } catch (error) {
        console.error("Erro ao carregar posts:", error);
      }
    };

    fetchPosts();
  }, [courseId]);

  const hasComments = displayPosts?.some(post => (post.answers?.length ?? 0) > 0);
  const title = hasComments ? 'Publicações mais comentadas' : 'Publicações mais recentes';
  if (displayPosts?.length === 0) return null;

  return (
    <Panel className="module-item" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <h4 style={{ marginBottom: '1rem', fontSize: '1.5rem', textAlign: 'center' }}>
        {title}
      </h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%' }}>
        {displayPosts?.map((post) => (
          <Panel key={post?._id}>
            <Link to={`/community/post/${courseId}/${post?._id}/${post?.category?._id}`} style={{ color: 'white' }}>
              <h5 style={{ margin: 0, fontSize: '1.3rem' }} dangerouslySetInnerHTML={{ __html: post?.title }} />
            </Link>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FontAwesomeIcon icon={SolidIcons[post?.category?.icon]} color={post?.category?.color || "#FFD700"} size="1x" />
                <small style={{ color: '#888', fontSize: '1rem' }}>{post?.category?.name || 'Discussão geral'}</small>
              </div>
              <small style={{ color: '#888', fontSize: '1rem' }}>
                {post?.answers?.length || 0} {post?.answers?.length === 1 ? 'comentário' : 'comentários'}
              </small>
            </div>
            <hr style={{ border: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />
          </Panel>
        ))}
      </div>
    </Panel>
  );
};

export default PostPanelList;
